import {assertAndContinue} from 'Asserts';
import {makeReactContext} from 'lib/makeReactContext';

/**
 * Tells all descendants whether the table they are rendering was initially collapsed.
 */

interface TableCollapserContextInterface {
  isTableInitiallyCollapsed: boolean;
}

export const TableCollapserContext = makeReactContext<TableCollapserContextInterface>(() => {
  assertAndContinue(false, 'TableCollapserContext consumer has no parent provider');
  return {isTableInitiallyCollapsed: false};
}, 'TableCollapserContext');
